import { useEffect, useState } from "react";
import bankService from "../../../Services/apiService/bank-service";
import RequestTable from "../../../Component/requestTable";
import { useAuth } from "../../../Utils/Auth";
import { customErrorHandler, toTitleCase } from "../../../Utils/helper";
import { toast } from "react-toastify";
import Loader from "../../../Component/loader";

const BankToBankTransferRequests = () => {
  const auth = useAuth()
  const [requests, setRequests] = useState([]);
  const [renderParrent, setrRnderParrent] = useState(null);
    const [paginationData, setPaginationData] = useState({
      page: 1,
      totalPages: 1,
      totalItems: 0,
      limit: 10,
    });
    const [isLoading, setIsLoading] = useState(false);

    const startIndex = Math.min(
      (paginationData.page - 1) * paginationData.limit + 1
    );
    const endIndex = Math.min(
      paginationData.page * paginationData.limit,
      paginationData.totalItems
    );

  const fetchData = async (page) => {
    const payload = {
      bankId: "",
      minAmount: "",
      maxAmount: "",
      startDate: "",
      endDate: ""
    }
    try{
    const res = await bankService.getBankToBankTransferRequest(payload, auth.user , page || paginationData.page, paginationData.limit);
    console.log("res", res )
    if(res){
         const data = res?.data?.data?.map((item) => ({
  ...item,
  createdAt: new Date(item.createdAt)
    .toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    })
    .replace(/am|pm/i, (match) => match.toUpperCase()),
        //For Future Use
        //   updatedAt: new Date(item.updatedAt).toLocaleString("en-IN", {
        //     timeZone: "Asia/Kolkata",
        //     day: "2-digit",
        //     month: "2-digit",
        //     year: "numeric",
        //     hour: "2-digit",
        //     minute: "2-digit",
        //     second: "2-digit",
        //     hour12: true,
        //   }),
      }));
      setRequests(data)
      setPaginationData((state) => ({
        ...state,
        page: res?.data?.pagination?.page,
        totalPages: res.data?.pagination?.totalPages,
        totalItems: res.data?.pagination?.totalItems,
        limit: res.data?.pagination?.limit,
      }));
    }
    }
    catch(err){
      toTitleCase(customErrorHandler(err.message, "Something went wrong"));
    }
  }

  useEffect(()=>{
    fetchData()
  },[renderParrent])


  const pageHandler = (selectedPage) => {
    fetchData(selectedPage);
  };


  const handleApprove = async (data) => {
    try {
      const payload = {
        status: "Approved",
      };
      setIsLoading(true)
      const res = await bankService.approveRejecttransferRequest(
        auth.user,
        payload,
        data?.transactionId
      );
      if (res){
      toast.success(toTitleCase(res?.data?.message));
      setrRnderParrent(res)
      }

    } catch (err) {
    toTitleCase(customErrorHandler(err))
    }
    setIsLoading(false)
  };

  const handleReject = async (data) => {
    try {
      const payload = {
        status: "Rejected",
      };
      setIsLoading(true)

      const res = await bankService.approveRejecttransferRequest(
        auth.user,
        payload,
        data?.transactionId
      );
      if (res)
        setrRnderParrent(res)
      toast.success(toTitleCase(res?.data?.message));
    } catch (err) {
      customErrorHandler(err)
    }
    setIsLoading(false)
  };

  return (
    <div className="container">
      <RequestTable
        data={requests}
        columns={[
          { field: 'createdAt', headerName: 'Date & Time' },
          { field: 'createdByName', headerName: 'Requested By' },
          { field: 'fromBankName', headerName: 'From Bank' },
          {
            field: 'toBankName',
            headerName: 'To Bank',
            
          },
            {
            field: 'amount',
            headerName: 'Amount',
            
          },
          // { field: 'transactionId', headerName: 'Transaction Id' },
          { field: 'status', headerName: 'Status' }
        ]}
        requestTypes={['New Bank Requests', 'Edit Bank Requests', 'Delete Bank Requests']}
        onApprove={handleApprove}
        onReject={handleReject}
        title="Bank To Bank Transfer Requests"
        filter = {{isFilterDropDownShow : false  , isFilterSearchShow : true}}
        page={paginationData.page}
        totalPage = {paginationData.totalPages}
        startIndex ={startIndex}
        endIndex={endIndex}
        totalData = {paginationData.totalItems}
        onPageChange = {pageHandler}
      />
      <Loader
        isLoading={isLoading}
        spinnerType="bar"
        color="#ff5722"
        message="Processing..."
      />
    </div>
  );
};


export default BankToBankTransferRequests;